import React from 'react';
import classNames from 'classnames';

import './style.scss';

class LoadingSpinner extends React.Component {
  render() {
    return (<div className={classNames('spinner', { hide: !this.props.isLoading })}>
    <div className="bounce1"></div>
    <div className="bounce2"></div>
    <div className="bounce3"></div>
  </div>)
  }
}

export default LoadingSpinner;